import { render, staticRenderFns } from "./AccountProjectIsLiveForm.vue?vue&type=template&id=45316586&"
import script from "./AccountProjectIsLiveForm.vue?vue&type=script&lang=ts&"
export * from "./AccountProjectIsLiveForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports